function r(t) {
  if (!t)
    return null;
  const n = t.getFullYear(), e = t.getMonth(), o = t.getDate();
  return `${n}-${e}-${o}`;
}
export {
  r as getCellUID
};
